import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
// import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Button, Chip, IconButton, Typography } from '@mui/material';
import {
  JobData,
  JobUserAssigned,
  MATCH,
  User,
} from 'components/JobQueue/utils';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { timeSince } from 'utils/ArrayConstants';

// import { MASTER_ENDPOINT } from 'utils/Constant';
import UserAssignModal from '../JobQueue/UserAssignModal';
import CloseJobComponent from './CloseJobComponent';

interface HeaderProps {
  jobTitle: string;
  company: string;
  location: string;
  timePosted: string;
  billRate: string;
  source: string;
  assignedUsers?: JobUserAssigned[];
  onBack: () => void;
  onCloseJob: () => void;
  users: User[];
  jobId: string;
  jobData?: JobData;
}

const Header: React.FC<HeaderProps> = ({
  jobTitle,
  company,
  location,
  timePosted,
  billRate,
  source,
  onBack,
  onCloseJob,
  assignedUsers: exisitngAssignedUsers,
  users,
  jobId,
  jobData,
}) => {
  const navigate = useNavigate();
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [assignedUsers, setAssignedUsers] = useState<JobUserAssigned[]>([]);
  const [closeJobModalOpen, setCloseJobModalOpen] = useState(false);

  const handleAssignClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setAssignModalOpen(true);
  };

  const handleAssignUser = (userId: string, type: 'add' | 'remove') => {
    if (type === 'remove') {
      const updatedAssignedUsers = assignedUsers.filter(
        (user) => user.userId !== userId,
      );
      setAssignedUsers(updatedAssignedUsers);
      setAssignModalOpen(false);
      setAnchorEl(null);
      return;
    }
    const userInfo = users.find((user) => user.id === userId);
    if (userInfo) {
      const newAssignedUser: JobUserAssigned = {
        assignedByFirstName: '',
        assignedByImageId: '',
        assignedByLastName: '',
        assignedByUserName: '',
        assignedToFirstName: userInfo?.firstName,
        assignedToImageId: userInfo?.imageId || null,
        assignedToLastName: userInfo?.lastName,
        assignedToUserName: userInfo?.firstName + ' ' + userInfo?.lastName,
        createdBy: userInfo.createdBy,
        id: userId,
        jobId,
        userId: userId,
      };
      setAssignedUsers((prev) => [...prev, newAssignedUser]);
    }
    setAssignModalOpen(false);
    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setAssignModalOpen(false);
    setAnchorEl(null);
  };

  const handleOpenCloseJobModal = () => {
    setCloseJobModalOpen(true);
  };

  const handleCloseJobModal = () => {
    setCloseJobModalOpen(false);
    onCloseJob();
  };

  React.useEffect(() => {
    if (exisitngAssignedUsers && exisitngAssignedUsers.length > 0)
      setAssignedUsers(exisitngAssignedUsers || []);
  }, [exisitngAssignedUsers]);

  console.log('Assigned Users in Header:', billRate, assignedUsers);
  return (
    <div
      style={{
        backgroundColor: '#FAFAFB',
        borderBottom: '1px solid #FAFAFB',
        padding: '24px',
      }}>
      {/* Job Details Row */}
      <div
        style={{
          alignItems: 'baseline',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}>
        <div
          style={{
            alignItems: 'self-end',
            display: 'flex',
            gap: '2px',
          }}>
          {/* Top Row - Back Button and Job Title */}
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
            }}
            onClick={() => navigate(-1)}>
            <IconButton
              onClick={onBack}
              sx={{
                '&:hover': {
                  backgroundColor: '#f3f4f6',
                },
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                marginRight: '12px',
                padding: '8px',
              }}>
              <ArrowBackIcon sx={{ color: '#6b7280', fontSize: '20px' }} />
            </IconButton>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
            }}>
            <Typography
              sx={{
                color: '#111827',
                fontFamily: 'Red Hat Display semibold',
                fontSize: '14px',
                fontWeight: '600',
              }}>
              {jobTitle}
            </Typography>
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
              }}>
              <Typography
                sx={{
                  display: 'flex',
                  fontFamily: 'Red Hat Display Regular',
                  fontSize: '12px',
                  fontWeight: '400',
                  gap: '4px',
                }}>
                <span
                  style={{
                    color: '#242424',
                  }}>
                  {' '}
                  {company}{' '}
                </span>{' '}
                <span
                  style={{
                    backgroundColor: '#0E700E',
                    borderRadius: '100%',
                    height: '4px',
                    marginRight: '6px',
                    marginTop: '4px',
                    width: '4px',
                  }}
                />{' '}
                <span
                  style={{
                    color: '#6b7280',
                  }}>
                  {location}{' '}
                </span>{' '}
                <span
                  style={{
                    backgroundColor: '#0E700E',
                    borderRadius: '100%',
                    height: '4px',
                    marginRight: '6px',
                    marginTop: '4px',
                    width: '4px',
                  }}
                />
                <span
                  style={{
                    color: '#6b7280',
                  }}>
                  {' '}
                  {timeSince(timePosted)} ago{' '}
                </span>
              </Typography>
            </div>
          </div>
        </div>

        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            gap: '12px',
          }}>
          {/* Assigned Users */}
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
            }}>
            {assignedUsers.map((user, index) => {
              const avatarColors = ['#EBF0FF', '#FFEBEB'];
              const bgColor = avatarColors[index % avatarColors.length];
              return (
                <div
                  key={user.id}
                  style={{
                    alignItems: 'center',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '6px',
                    display: 'flex',
                    flexShrink: 0,
                    fontFamily: 'Red Hat Display Medium',
                    fontSize: '10px',
                    fontWeight: '500',
                    height: '32px',
                    justifyContent: 'center',
                    marginLeft: index > 0 ? '-7px' : '0',
                    overflow: 'hidden',
                    width: '32px',
                  }}>
                  <span
                    style={{
                      alignItems: 'center',
                      backgroundColor: bgColor,
                      borderRadius: '6px',
                      display: 'flex',
                      height: '28px',
                      justifyContent: 'center',
                      padding: '2px',
                      width: '28px',
                    }}>
                    {user?.assignedToFirstName?.charAt(0).toUpperCase() || ''}
                    {user?.assignedToLastName?.charAt(0).toUpperCase() || ''}
                  </span>
                </div>
              );
            })}
            <button
              onClick={handleAssignClick}
              style={{
                alignItems: 'center',
                backgroundColor: '#f3f4f6',
                border: '1px solid #e5e7eb',
                borderRadius: '4px',
                color: '#6b7280',
                cursor: 'pointer',
                display: 'flex',
                flexShrink: 0,
                fontSize: '12px',
                height: '32px',
                justifyContent: 'center',
                marginLeft: '-5px',
                width: '32px',
              }}>
              <AddCircleOutlineIcon sx={{ fontSize: '16px' }} />
            </button>
          </div>

          {/* Close Job Button */}
          <Button
            onClick={handleOpenCloseJobModal}
            startIcon={<CloseIcon sx={{ fontSize: '16px' }} />}
            sx={{
              '&:hover': {
                backgroundColor: '#fef2f2',
              },
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '8px',
              color: '#dc2626',
              fontFamily: 'Red Hat Display Medium',
              fontSize: '12px',
              fontWeight: '500',
              padding: '6px 12px',
              textTransform: 'none',
            }}>
            Close Job
          </Button>
        </div>
      </div>

      {/* Tags */}
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          gap: '8px',
          marginTop: '12px',
          paddingLeft: '47px',
        }}>
        <Chip
          icon={
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '50%',
                height: '6px',
                width: '6px',
              }}
            />
          }
          label={
            MATCH.find((item) => item.key === jobData?.candidateMatchStatus)
              ?.label
          }
          sx={{
            '& .MuiChip-icon': {
              color: 'white',
              marginLeft: '8px',
            },
            backgroundColor: MATCH.find(
              (item) => item.key === jobData?.candidateMatchStatus,
            )?.bgColor,
            border:
              '1px solid ' +
              MATCH.find((item) => item.key === jobData?.candidateMatchStatus)
                ?.borderColor,
            color: 'white',
            fontFamily: 'Red Hat Display semibold',
            fontSize: '10px',
            fontWeight: '600',
          }}
        />
        <Chip
          label={`Bill Rate • ${billRate}`}
          sx={{
            backgroundColor: '#f3f4f6',
            border: '1px solid #f3f4f6',
            color: '#374151',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '10px',
            fontWeight: '600',
          }}
        />
        <Chip
          label={source}
          sx={{
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#dc2626',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '10px',
            fontWeight: '600',
            height: '20px',
            textTransform: 'capitalize',
          }}
        />
      </div>
      {/* Assigned Users and Actions Row */}

      {/* User Assign Modal */}
      <UserAssignModal
        open={assignModalOpen}
        onClose={handleCloseModal}
        onAssignUser={handleAssignUser}
        jobId={jobId}
        jobTitle={jobTitle}
        anchorEl={anchorEl}
        users={users}
        exisitngAssignedUsers={assignedUsers}
      />

      {/* Close Job Modal */}
      {jobData && (
        <CloseJobComponent
          open={closeJobModalOpen}
          onClose={handleCloseJobModal}
          jobData={jobData}
        />
      )}
    </div>
  );
};

export default Header;
